import { customElement } from 'solid-element';
import { Standard, Popup } from './kind';

import {
  WIDGET_NAMES,
  WIDGET_KIND,
  defaultSearchProps,
  defaultPopupProps,
} from './types/constants';

export const registerWebComponents = () => {
  if (typeof window === 'undefined') return;
  customElement(
    WIDGET_NAMES[WIDGET_KIND.STANDARD],
    defaultSearchProps,
    Standard as any,
  );
  customElement(
    WIDGET_NAMES[WIDGET_KIND.POPUP],
    defaultPopupProps,
    Popup as any,
  );
};
